import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';

import LeviaFwuArticle from '../../../components/Levia/LeviaFwu/LeviaFwuArticle';
import {PopupMobileFullPage} from '../../../components/Popup';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import modalService from '../../../services/modalService';
import storageService from '../../../services/storage/storageService';
import {selectLeviaRelatedTargetSerialNumber} from '../../../state/selectors/iotDevice';
import elementsTesIds from '../../../test/consts/elementsTesIds';

const LeviaFwuPopup = ({modalType}) => {
    const localizedStrings = getLocalizedStrings();
    const serialNumber = useSelector(selectLeviaRelatedTargetSerialNumber);
    const onClose = () => modalService.hideModal(modalType);

    useEffect(() => {
        storageService.setLeviaPopupsDataToLocalStorageBySerialNumber({serialNumber, wasShownFwu: true});
    }, [serialNumber]);

    return (
        <PopupMobileFullPage
            contentLabel={localizedStrings[localizationKeys.FIRMWARE_MODAL_VIEW_TITLE]}
            onClose={onClose}
            closeButtonAriaLabel={localizedStrings[localizationKeys.FIRMWARE_MODAL_VIEW_CLOSE_BUTTON_ARIA_LABEL]}
            isCloseVisible
            closeButtonTestId={elementsTesIds.DEVICE_SETTINGS_BTN_CLOSE}
        >
            <div className='flex justify-center px-8 pb-8 pt-18 md:p-0'>
                <LeviaFwuArticle onClick={onClose} onCancel={onClose} />
            </div>
        </PopupMobileFullPage>
    );
};

export default LeviaFwuPopup;
